module.exports = __webpack_public_path__ + "static/media/avataaars.b388f903.png";